import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { ShiftDetailCard } from './ShiftDetailCard';
export const ShiftCheckInCard = ({ displayShiftContact, addressPermission, locationName, address, address2, city, state, zip, county, }) => {
    const { t } = useMissionsTranslation();
    const conditionalAddressDisplay = (addressPermission) => {
        let partialAddress = '';
        if (addressPermission === 'cityOnly') {
            partialAddress = city;
        }
        else if (addressPermission === 'countyOnly') {
            partialAddress = county;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: 'body2' }, partialAddress),
            React.createElement(Typography, { variant: 'body2', sx: { color: (theme) => theme.palette.grey[500] } }, t('shifts.notDisplayingFullAddress'))));
    };
    return (React.createElement(ShiftDetailCard, { title: t('missions.missionDetails.shiftCheckIn') },
        React.createElement(Box, { color: themeColors.text.subtle, "data-test": 'shift-check-in-card' }, displayShiftContact || addressPermission === 'fullAddress' ? (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: 'body2' }, locationName),
            React.createElement(Typography, { variant: 'body2' }, address),
            React.createElement(Typography, { variant: 'body2' },
                address2,
                " "),
            React.createElement(Typography, { variant: 'body2' },
                city,
                ", ",
                state,
                ", ",
                zip),
            React.createElement(Typography, { variant: 'body2' }, county))) : (conditionalAddressDisplay(addressPermission)))));
};
